import React from 'react'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'

import {
  customerTypes,
  errorCodesWithMessages,
  DEFAULT_EMPTY_ADDRESS_OBJECT,
} from '../../../util/constants'
import PersonFormFields from './person-form-fields/person-form-fields'
import CompanyFormFields from './company-form-fields/company-form-fields'
import { Checkbox, TabInput } from '../../inputs/index'
import { BaseFormFields } from './index'

import styles from './address-form.css'

const { COMPANY, PERSON } = customerTypes
const TAB_INDICES = { [COMPANY]: 0, [PERSON]: 1 }
const TAB_ITEMS = [COMPANY, PERSON]

class AddressForm extends React.Component {
  constructor(props) {
    super(props)

    const { data } = props

    this.state = {
      customerKind: data && data.kind ? data.kind : COMPANY,
      data: data || DEFAULT_EMPTY_ADDRESS_OBJECT,
    }

    this.formErrors = {
      companyName: '',
      lastName: '',
    }
    this.onTabInputChange = this.onTabInputChange.bind(this)
    this.onTextInputChange = this.onTextInputChange.bind(this)
    this.handleBaseInputChange = this.handleBaseInputChange.bind(this)
    this.onSalutationChanged = this.onSalutationChanged.bind(this)
    this.onTitleChanged = this.onTitleChanged.bind(this)
    this.onTriggerDataChange = this.onTriggerDataChange.bind(this)
    this.onDefaultBillingAddressChange = this.onDefaultBillingAddressChange.bind(this)
    this.onDefaultDeliveryAddressChange = this.onDefaultDeliveryAddressChange.bind(this)
  }

  componentWillReceiveProps(newProps) {
    const { data } = newProps

    if (data) {
      return this.setState({ data, customerKind: data.kind || COMPANY })
    }

    this.setState({
      data: { ...DEFAULT_EMPTY_ADDRESS_OBJECT },
      customerKind: COMPANY,
    })
  }

  onTriggerDataChange() {
    const { customerKind, data } = this.state
    const { onDataChanged } = this.props
    const assignedData = Object.assign({}, data, { kind: customerKind })

    onDataChanged && onDataChanged(assignedData)
  }

  onTabInputChange(index) {
    const { data } = this.state
    data.kind = TAB_ITEMS[index]
    if (data.kind === COMPANY) {
      data.companyName = data.lastName
      data.firstName = ''
      data.lastName = ''
    } else {
      data.lastName = data.companyName
      data.companyName = ''
      data.companyNameAffix = ''
    }

    this.setState({ customerKind: TAB_ITEMS[index] })
  }

  onSalutationChanged(option) {
    const { data } = this.state
    data.salutation = option
    this.setState({ data }, this.onTriggerDataChange)
  }

  onTitleChanged(option) {
    const { data } = this.state
    data.title = option
    this.setState({ data }, this.onTriggerDataChange)
  }

  onTextInputChange(value, name) {
    const { data } = this.state
    data[name] = value
    this.setState({ data }, this.onTriggerDataChange)
  }

  onDefaultBillingAddressChange(value) {
    const { data } = this.state
    data.isDefaultBilling = value
  }

  onDefaultDeliveryAddressChange(value) {
    const { data } = this.state
    data.isDefaultDelivery = value
  }

  handleBaseInputChange(changedValues) {
    const { data } = this.state
    this.setState({ data: { ...data, ...changedValues } }, this.onTriggerDataChange)
  }

  clearForm() {
    this.form.reset()
  }

  render() {
    const { data, customerKind } = this.state
    const { customContainerClass, errors, dataQsId } = this.props
    const {
      isDefaultBilling,
      isBillingDisabled,
      isDefaultDelivery,
      isDeliveryDisabled,
    } = data

    if (!isEmpty(errors)) {
      for (const name in errors) {
        const errorCode = errors[name][0].code
        const filteredError = find(errorCodesWithMessages, (error) => {
          return error.type === errorCode
        })

        this.formErrors = { ...this.formErrors, [name]: filteredError.message }
      }
    }

    const companyFields = (
      <CompanyFormFields
        data={data}
        errors={this.formErrors}
        onTextInputChange={this.onTextInputChange} />
    )
    const personFields = (
      <PersonFormFields
        data={data}
        errors={this.formErrors}
        onSalutationChanged={this.onSalutationChanged}
        onTitleChanged={this.onTitleChanged}
        onTextInputChange={this.onTextInputChange} />
    )
    const baseFields = (
      <BaseFormFields
        data={data}
        onChange={this.handleBaseInputChange} />
    )

    return (
      <div className={`${styles.container} ${customContainerClass || ''}`} data-qs-id={dataQsId}>
        <form ref={(form) => { this.form = form }}>
          <TabInput
            ref='toggleCompanyPerson'
            key='toggleCompanyPerson'
            customClass={styles.tabInput}
            tabs={[
              { key: COMPANY, label: 'Firma', content: companyFields },
              { key: PERSON, label: 'Privat', content: personFields },
            ]}
            value={TAB_INDICES[customerKind] || 0}
            onChange={this.onTabInputChange} />
          {baseFields}
          <div className={styles.row}>
            <div className='col-xs-6'>
              <Checkbox
                checked={isDefaultBilling}
                disabled={isBillingDisabled}
                name='defaultBilling'
                onChange={this.onDefaultBillingAddressChange}>
                <span className={styles.checkboxLabel}>Standard Rechnungsadresse</span>
              </Checkbox>
            </div>
          </div>
          <div className={styles.row}>
            <div className='col-xs-6'>
              <Checkbox
                checked={isDefaultDelivery}
                disabled={isDeliveryDisabled}
                name='defaultDelivery'
                onChange={this.onDefaultDeliveryAddressChange}>
                <span className={styles.checkboxLabel}>Standard Lieferadresse</span>
              </Checkbox>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default AddressForm
